import React from 'react';

const RightTranscriptAccordion = ({
  title = 'Live Transcript',
  isOpen = true,
  onToggle,
  children
}) => (
  <aside className={`frontoffice-right-accordion ${isOpen ? 'is-open' : 'is-closed'}`}>
    <button
      type="button"
      className="frontoffice-right-accordion-tab"
      onClick={onToggle}
      aria-expanded={isOpen}
      aria-controls="frontoffice-transcript-accordion-panel"
      title={isOpen ? `Collapse ${title}` : `Open ${title}`}
    >
      <span className="frontoffice-right-accordion-tab-text">{title}</span>
      <i className={`bi ${isOpen ? 'bi-chevron-right' : 'bi-chevron-left'}`}></i>
    </button>

    <div
      id="frontoffice-transcript-accordion-panel"
      className="frontoffice-right-accordion-content"
      aria-hidden={!isOpen}
    >
      <div className="frontoffice-right-accordion-content-inner">
        {children}
      </div>
    </div>
  </aside>
);

export default RightTranscriptAccordion;
